<script>
	import appConfig from '@src/app.config'
	import Layout from '@layouts/_main'
	import PageHeader from '@components/page-header'

	import { customerApi } from '@router/apiFiles/customerApi'
	import { userApi } from '@router/apiFiles/userApi'
	
	export default {
		page: {
			title: 'Create User',
			meta: [{ name: 'description', content: appConfig.description }],
		},
		components: {
			Layout,
			PageHeader,
		},
		data() {
			return {
                items: [
                    {
                        text: 'OnBoard',
                        href: '/',
                    },
                    {
                        text: 'Users',
                        href: '/',
                    },
                    {
                        text: 'Create',
                        active: true,
                    },
				],
                isBusy: true,
                user: {
					name: '',
					password: '',
					email: '',
					blocked: false
				},
				customers: []
			}
		},
        props: {
            number: {
                type: String,
                default: null
            }
		},
		computed: {
			orderIsValid() {
            },
        },
		mounted() {
			this.fetchData().catch(error => {
				console.error(error)
			})
		},
		methods: {
			async fetchData() {
				var self = this;
				self.isBusy = false;
				customerApi.searchCustomers({ search: '', page: 1, perPage: 50 })
					.then(function (data) {
						self.customers = data.data;
					});			
			},		
            save() {
				var self = this;
				self.isBusy = true;
				self.show = false;
				userApi.createUser({ name:self.user.name, email:self.user.email, password:self.user.password, blocked: false, customerId: self.user.customerId })
					.then(function (data) {
						self.isBusy = false;
						self.$router.push('/searchusers');
					});
			},

		}
	}
</script>

<template>
	<Layout>
		<PageHeader :title="title" :items="items" />
		<b-overlay :show="isBusy">
			<div class="row">

				<div class="col-lg-6">
					<div class="card">
						<div class="card-body">
							<h4 class="header-title mb-3">Create User</h4>
											
							<!-- Customer -->
							<div class="col-sm-6 col-md-4">
								<div class="form-group">
									<label>Customer</label>
									<div>
										<select class="form-control" v-model="user.customerId" style="max-width:100%">
											<option v-for="customer of customers" v-bind:key="customer.id" v-bind:value="customer.id">{{customer.name}}</option>
										</select>
									</div>
								</div>
							</div>
							<!-- End Customer -->
											
							<div class="row">
								<div class="col-lg-6">
									<div class="mb-4">
										<h5 class="mt-0">Name</h5>
										<b-form-input v-model="user.name"></b-form-input>
									</div>
								</div>
								<div class="col-lg-6">
									<div class="mb-4">
										<h5 class="mt-0">Password</h5>
										<b-form-input v-model="user.password"></b-form-input>
									</div>
								</div>								
							</div>
							
							<div class="row">
								<div class="col-lg-12">
									<div class="mb-4">
										<h5 class="mt-0">Email</h5>
										<b-form-input v-model="user.email"></b-form-input>
									</div>
								</div>								
							</div>
							
							<div class="row">
								<div class="col-lg-12">
									<a href="javascript: void(0);" @click="save()" class="btn btn-primary btn-sm float-right">Save<i class="uil uil-edit ml-1"></i></a>
								</div>
							</div>

						</div>
					</div>
				</div>
				
			</div>


		</b-overlay>
	</Layout>
</template>
